import React from "react";
import Typed from "react-typed";
import AOS from "aos";
import Pdf from "../assets/document/AbdulSami CV.pdf";
AOS.init({
	offset: 200,
	duration: 800,
	easing: "ease-in-out-sine",
	delay: 200,
	mirror: true,
});

const hero = () => {
	return (
		<div className="v-center">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-md-6">
						<h6
							className="color"
							data-aos="fade-up"
							data-aos-delay="0"
							data-aos-duration="1000"
							data-aos-easing="ease"
							data-aos-once="true"
						>
							Welcome
						</h6>
						<div className="spacer-20"></div>
						<div className="h1_big">Hi, I'm Abdul Sami</div>
						<div
							className="h1_big"
							data-aos="fade-up"
							data-aos-delay="300"
							data-aos-duration="1000"
							data-aos-easing="ease"
							data-aos-once="true"
						>
							<Typed
								strings={["JS Developer. ", "a Frontend Developer."]}
								typeSpeed={60}
								backSpeed={50}
								loop
							/>
						</div>
						<ul
							className="list_location"
							data-aos="fade-up"
							data-aos-delay="600"
							data-aos-duration="1000"
							data-aos-easing="ease"
							data-aos-once="true"
						>
							<li>
								<span>Pakistan</span>Lahore
							</li>
						</ul>
						{/* <button className="btn-main mt-3">My Resume</button> */}
						<a href={Pdf} without rel="noopener noreferrer" target="_blank">
							<button className="btn-main ">Resume</button>
						</a>
					</div>

					<div className="col-md-6">
						{/* <img src="./img/misc/8.jpg" className="img-fluid" alt="imghero"/> */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default hero;
